<template>
	<div class="mobile_banner_wrapper">
		<!-- 배경 레이어 (배너 영역 외) -->
		<div class="banner_overlay" @click="$emit('close')"></div>

		<!-- 배너 영역 -->
		<div class="mobile_banner">
			<div class="mobile_banner_container">
				<div class="banner_image_container" @click="goBannerLink">
					<img :src="banner.imgPathMo" alt="" />
				</div>
				<!-- 오늘 하루 보지 않기 버튼과 닫기 버튼 -->
				<div class="banner_controls">
					<button type="button" class="btn_not_today" @click="doNotShowToday">
						오늘 하루 보지 않기
					</button>
					<button type="button" class="btn_close_banner" @click="$emit('close')">
						닫기
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "MobileBanner",
	props: {
		banner: {
			type: Object,
			required: true
		}
	},
	emits: ['close', 'click', 'notToday'],
	methods: {
		// 단순히 이벤트만 전달
		goBannerLink() {
			this.$emit('click', this.banner);
			this.$emit('close');
		},
		doNotShowToday() {
			this.$emit('notToday');
			this.$emit('close');
		}
	}
}
</script>

<style scoped>
/* 전체 wrapper */
.mobile_banner_wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
}

/* 오버레이 배경 */
.banner_overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(50, 49, 49, 0.4);
}

/* 모바일 전용 스타일 */
.mobile_banner {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	display: flex;
	justify-content: center;
	z-index: 1001;
}

/* 배너 컨테이너 */
.mobile_banner_container {
	position: relative;
	width: 100%;
	max-width: 420px;
	margin: 0 auto;
	padding: 0;
	background-color: #fff;
	border: none;
	border-radius: 20px 20px 0 0;
	/* 상단만 둥글게 */
	overflow: hidden;
}

/* 이미지 컨테이너 */
.banner_image_container {
	width: 100%;
	border: none;
	border-radius: 20px 20px 0 0;
	overflow: hidden;
	text-align: center;
	cursor: pointer;
	margin: 0;
	padding: 0;
	background: transparent;
}

/* 이미지 스타일 */
.banner_image_container img {
	max-width: 100%;
	width: 100%;
	height: auto;
	display: block;
	max-height: 60vh;
	border: none;
	margin: 0;
	padding: 0;
	vertical-align: top;
	border-radius: 20px 20px 0 0;
}

/* 배너 컨트롤 영역 */
.banner_controls {
	width: 100%;
	display: flex;
	justify-content: center;
	/* 버튼을 가운데 정렬 */
	align-items: center;
	text-align: center;
	background-color: #fff;
	border-top: 1px solid #eee;
	margin: 0;
	padding: 0;
	border-radius: 0 0 20px 20px;
	gap: 0;
	/* 버튼 사이 간격 조정 필요시 gap 사용 */
}

/* 버튼 스타일 */
.banner_controls button {
	flex: 1 1 0;
	padding: 14px 0;
	font-size: 16px;
	border: none;
	background: none;
	cursor: pointer;
}

/* 오늘 하루 보지 않기 버튼 스타일 */
.btn_not_today {
	border-right: 1px solid #eee;
}

/* 닫기 버튼 스타일 */
.btn_close_banner {
	border-left: 1px solid #eee;
}

/* 기본 스타일 리셋 */
.mobile_banner_container * {
	box-sizing: border-box;
}

/* iOS Safari 최적화 */
@supports (-webkit-touch-callout: none) {
	.banner_image_container img {
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
	}
}

/* 원형 닫기 버튼 */
.mobile_close_btn {
	position: absolute;
	top: 20px;
	/* 변경: -20px → 20px (내부로 이동) */
	right: 20px;
	/* 변경: -20px → 20px (내부로 이동) */
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background-color: rgba(51, 51, 51, 0.8);
	border: none;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	z-index: 10;
}

/* X 표시 만들기 */
.mobile_close_btn::before,
.mobile_close_btn::after {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	width: 16px;
	height: 2px;
	background-color: white;
}

.mobile_close_btn::before {
	transform: translate(-50%, -50%) rotate(45deg);
}

.mobile_close_btn::after {
	transform: translate(-50%, -50%) rotate(-45deg);
}

/* 버튼 호버 효과 */
.banner_controls button:hover {
	background-color: #f5f5f5;
}

/* 스크린 리더용 텍스트 */
.sr-only {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
}

/* 다양한 둥근 모서리 옵션들 */

/* 옵션 1: 전체 둥글게 */
.mobile_banner_container.full-rounded {
	border-radius: 20px;
}

.mobile_banner_container.full-rounded .banner_image_container {
	border-radius: 20px 20px 0 0;
}

.mobile_banner_container.full-rounded .banner_controls {
	border-radius: 0 0 20px 20px;
}

/* 옵션 2: 더 둥글게 */
.mobile_banner_container.extra-rounded {
	border-radius: 30px 30px 0 0;
}

.mobile_banner_container.extra-rounded .banner_image_container,
.mobile_banner_container.extra-rounded .banner_image_container img {
	border-radius: 30px 30px 0 0;
}

.mobile_banner_container.extra-rounded .banner_controls {
	border-radius: 0 0 30px 30px;
}

/* 옵션 3: 살짝만 둥글게 */
.mobile_banner_container.subtle-rounded {
	border-radius: 12px 12px 0 0;
}

.mobile_banner_container.subtle-rounded .banner_image_container,
.mobile_banner_container.subtle-rounded .banner_image_container img {
	border-radius: 12px 12px 0 0;
}

.mobile_banner_container.subtle-rounded .banner_controls {
	border-radius: 0 0 12px 12px;
}

/* 옵션 4: iOS 스타일 둥근 모서리 */
.mobile_banner_container.ios-style {
	border-radius: 16px 16px 0 0;
}

.mobile_banner_container.ios-style .banner_image_container,
.mobile_banner_container.ios-style .banner_image_container img {
	border-radius: 16px 16px 0 0;
}

.mobile_banner_container.ios-style .banner_controls {
	border-radius: 0 0 16px 16px;
}
</style>